module.exports = __webpack_public_path__ + "static/media/toolbar.23a4dcfc.png";